import classNames from "classnames";
import type React from "react";

import style from "./HamburgerCloseIcon.module.css";

export type HamburgerCloseIconProps = {
  className?: string;
  open: boolean;
  onClick?: () => void;
};

export const HamburgerCloseIcon: React.FC<HamburgerCloseIconProps> = ({
  className,
  open,
  onClick,
}) => {
  return (
    <div className={classNames(style.icon, open && style.open, className)} onClick={onClick}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};
